
import { Vue, Component, Prop } from "vue-property-decorator";
import Chip from "@/components/common/Chip.vue";

@Component({
    components: {
        Chip
    }
})
export default class ChipWithLink extends Vue {
    @Prop({ type: String, default: "" }) readonly variant!: string;
    @Prop({ type: Object, default: undefined }) readonly chipLink!: object;
    @Prop({ type: Object, default: () => { return { id: "", name: "" } } }) readonly chipData!: string;
    @Prop({ type: String, default: "" }) readonly avatar!: string;
    @Prop({ type: String, default: "" }) readonly chipText!: string;
      @Prop({ type: String, default: "" }) readonly chipClassParent!: string;
    @Prop({ type: Boolean, default: false }) readonly wrapChip!: boolean;
}
